import { render, staticRenderFns } from "./MemberAccessModal.vue?vue&type=template&id=bf3ccaaa&scoped=true"
import script from "./MemberAccessModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberAccessModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MemberAccessModal.vue?vue&type=style&index=0&id=bf3ccaaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3ccaaa",
  null
  
)

export default component.exports